import {
  Button,
  Colors,
  TextBold,
  TextReg,
  useDynamicStyles,
  type WithResponsive,
} from '@sunrise-ui/primitives';
import React, { type ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';

type Props = {
  title: string;
  description?: string;
  children: ReactNode;
  onSeeMore?: () => void;
  showSeeMore?: boolean;
};

export function SponsorshipSection({
  title,
  description,
  children,
  onSeeMore,
  showSeeMore = true,
}: Props) {
  const styles = useDynamicStyles(createStyles);

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <TextBold style={styles.title}>{title}</TextBold>
        {description && (
          <TextReg style={styles.description}>{description}</TextReg>
        )}
      </View>
      <View style={styles.content}>{children}</View>
      {showSeeMore && (
        <View style={styles.footer}>
          <Button mode="contained" size="small" onPress={onSeeMore}>
            See More
          </Button>
        </View>
      )}
    </View>
  );
}

const createStyles = ({ isMobile }: WithResponsive) =>
  StyleSheet.create({
    container: {
      backgroundColor: Colors.opacity05,
      borderRadius: isMobile ? 16 : 20,
      padding: isMobile ? 16 : 24,
    },
    header: {
      marginBottom: isMobile ? 16 : 20,
    },
    title: {
      fontSize: isMobile ? 18 : 22,
      color: Colors.text,
      marginBottom: 8,
    },
    description: {
      fontSize: isMobile ? 12 : 14,
      color: Colors.opacity50,
      lineHeight: isMobile ? 18 : 20,
    },
    content: {
      gap: 16,
    },
    footer: {
      marginTop: isMobile ? 16 : 20,
      alignItems: 'center',
    },
  });
